import axios from 'axios';

const n8nApi = axios.create({
  baseURL: 'https://n8n.bibi.com.br/webhook/bibi',
});

export default n8nApi;
